import { Suspense } from 'react';

import { DrawdownChoice } from './DrawdownChoice';
import { ErrorBoundary } from '../../../../../errorBoundary/ErrorBoundary';
import FallbackErrorModal from '../../../../modals/fallbackErrorModal/FallbackErrorModal';
import MainContentPending from '../../../../pageStructure/mainContentPending';

export const TopUpPanel = ({ accountId }: { accountId: string }) => {
    return (
        <ErrorBoundary
            fallback={() => {
                return <FallbackErrorModal />;
            }}
        >
            <Suspense
                fallback={
                    <div className="flex-1 rounded-m bg-structure-100 p-l shadow-black-s">
                        <MainContentPending />
                    </div>
                }
            >
                <DrawdownChoice accountId={accountId} />
            </Suspense>
        </ErrorBoundary>
    );
};
